import { Directive, HostBinding } from '@angular/core';
import { StaticInjector } from 'shared.root/helpers/static-injector';

@Directive()  
export class ContentPage {
  @HostBinding('class.nim__content') nimContentClass = true;

  constructor() {
    // These are only not set in unit tests, where they don't matter
    if (StaticInjector && StaticInjector.injector) {
    }
  }
}
